module.exports = __webpack_public_path__ + "img/PreviousExhibitors2.bbeca056.svg";